import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import ProfilePage from './components/ProfilePage/ProfilePage';

// Set a `basename` to be used by the Router
const basename = process.env.NODE_ENV === 'production' ? '/user-profile' : '/';

const Routes = () => (
  <Router basename={basename}>
    <Route path="/:userId?" component={ProfilePage}></Route>
  </Router>
);

const Main = () => (
  <Routes />
);

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js